import ListActions from "../../../List/actions";
import {put} from "../../../../shared/SagaService";
import {take} from 'redux-saga/effects';

/**
 *
 * @param {*} lists - list of data to read, eg [L.product_detail_list]
 * @param {*} params - parameters for each list data, eg: {
*                       [L.product_detail_list]: {
                            product_ids: productIds,
                            type: 'PURCHASE',
                            date: dayjs().format("YYYY-MM-DD")
                        }}
 * @param {*} showSpinner
 * @param {*} forceMode
 */
export function* readLists(lists, params = {}, showSpinner = false, forceMode = false) {
    if (lists.length) {
        const requestAction = ListActions.readLists(lists, params, showSpinner, forceMode);
        yield put(requestAction);

        // console.log('qq requestAction', requestAction);
        const { requesterId } = requestAction;

        let loop = true;
        while (loop) {
            const successAction = yield take(ListActions.LIST_READ_LISTS_SUCCESS);
            if (successAction.requesterIds.includes(requesterId))
                loop = false;
        }
    }
}
